import { __assign, __read, __rest } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { alignToBottomSystem } from './alignToBottomSystem';
import { domIOSystem } from './domIOSystem';
import { followOutputSystem } from './followOutputSystem';
import { groupedListSystem } from './groupedListSystem';
import { initialItemCountSystem } from './initialItemCountSystem';
import { initialScrollTopSystem } from './initialScrollTopSystem';
import { initialTopMostItemIndexSystem } from './initialTopMostItemIndexSystem';
import { listStateSystem } from './listStateSystem';
import { loggerSystem } from './loggerSystem';
import { propsReadySystem } from './propsReadySystem';
import { scrollIntoViewSystem } from './scrollIntoViewSystem';
import { scrollSeekSystem } from './scrollSeekSystem';
import { scrollToIndexSystem } from './scrollToIndexSystem';
import { sizeRangeSystem } from './sizeRangeSystem';
import { sizeSystem } from './sizeSystem';
import { topItemCountSystem } from './topItemCountSystem';
import { totalListHeightSystem } from './totalListHeightSystem';
import { upwardScrollFixSystem } from './upwardScrollFixSystem';
import { windowScrollerSystem } from './windowScrollerSystem';
// workaround the growing list of systems below
// fix this with 4.1 recursive conditional types
var featureGroup1System = u.system(function (_a) {
    var _b = __read(_a, 9), sizeRange = _b[0], initialItemCount = _b[1], propsReady = _b[2], scrollSeek = _b[3], totalListHeight = _b[4], initialScrollTopSystem = _b[5], alignToBottom = _b[6], windowScroller = _b[7], scrollIntoView = _b[8];
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, sizeRange), initialItemCount), propsReady), scrollSeek), totalListHeight), initialScrollTopSystem), alignToBottom), windowScroller), scrollIntoView);
}, u.tup(sizeRangeSystem, initialItemCountSystem, propsReadySystem, scrollSeekSystem, totalListHeightSystem, initialScrollTopSystem, alignToBottomSystem, windowScrollerSystem, scrollIntoViewSystem));
export var listSystem = u.system(function (_a) {
    var _b = _a, _c = __read(_b, 11), _d = _c[0], totalCount = _d.totalCount, sizeRanges = _d.sizeRanges, fixedItemSize = _d.fixedItemSize, defaultItemSize = _d.defaultItemSize, trackItemSizes = _d.trackItemSizes, itemSize = _d.itemSize, data = _d.data, firstItemIndex = _d.firstItemIndex, groupIndices = _d.groupIndices, statefulTotalCount = _d.statefulTotalCount, _e = _c[1], initialTopMostItemIndex = _e.initialTopMostItemIndex, scrolledToInitialItem = _e.scrolledToInitialItem, domIO = _c[2], followOutput = _c[3], _f = _c[4], scrollToIndex = _c[5].scrollToIndex, topItemCount = _c[7].topItemCount, groupCounts = _c[8].groupCounts, featureGroup1 = _c[9], log = _c[10], listState = _f.listState, topItemsIndexes = _f.topItemsIndexes, flags = __rest(_f, ["listState", "topItemsIndexes"]);
    u.connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
    u.connect(u.pipe(featureGroup1.windowViewportRect, u.map(u.prop('visibleHeight'))), domIO.viewportHeight);
    return __assign(__assign(__assign(__assign(__assign(__assign({ 
        // input
        totalCount: totalCount,
        data: data,
        firstItemIndex: firstItemIndex,
        sizeRanges: sizeRanges,
        initialTopMostItemIndex: initialTopMostItemIndex,
        scrolledToInitialItem: scrolledToInitialItem,
        topItemsIndexes: topItemsIndexes,
        topItemCount: topItemCount,
        groupCounts: groupCounts, fixedItemHeight: fixedItemSize, defaultItemHeight: defaultItemSize }, followOutput), { 
        // output
        statefulTotalCount: statefulTotalCount,
        listState: listState,
        scrollToIndex: scrollToIndex,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize,
        groupIndices: groupIndices }), flags), featureGroup1), domIO), log);
}, u.tup(sizeSystem, initialTopMostItemIndexSystem, domIOSystem, followOutputSystem, listStateSystem, scrollToIndexSystem, upwardScrollFixSystem, topItemCountSystem, groupedListSystem, featureGroup1System, loggerSystem));
